import { HTMLProps } from 'react';
import { Tooltip } from '../Tooltip';
import { TooltipIndicator } from '../TooltipIndicator';

export const FormGroup: React.FC<
    {
        title?: {
            tooltip?: {
                title: string;
                text: string;
            };
            label: string;
        };
    } & Omit<HTMLProps<HTMLDivElement>, 'title' | 'value' | 'onChange' | 'suffix'>
> = ({ title, children, className, ...rest }) => {
    return (
        <div className={`flex flex-col ${className}`} {...rest}>
            {title && (
                <div className="flex items-center justify-between mb-2">
                    {title.label}
                    {!!title.tooltip && (
                        <Tooltip
                            tooltipId={title.tooltip.title}
                            tooltipTitle={title.tooltip.title}
                            tooltipText={title.tooltip.text}
                            className="ml-2"
                        >
                            <TooltipIndicator>?</TooltipIndicator>
                        </Tooltip>
                    )}
                </div>
            )}
            {children}
        </div>
    );
};
